import React from "react";
import { CountdownText, CountdownTextHandle } from "../countdown-text/CountdownText";
import styles from "./OtpVerificationCard.module.scss";

export interface OtpVerificationCardProps {
	title: string;
	subtitle: React.ReactNode;
	value: string;
	onChange: (v: string) => void;
	isVerifying?: boolean;
	placeholder?: string;
	inputType?: "text" | "number" | "password";
	countdownRef?: React.RefObject<CountdownTextHandle>;
	timerDurationInSeconds?: number;
	startTimerOnInit?: boolean;
	onResend?: () => void;
	errorMessage?: string;
}

export const OtpVerificationCard: React.FC<OtpVerificationCardProps> = ({
	title,
	subtitle,
	value,
	onChange,
	isVerifying = false,
	placeholder = "Type..",
	inputType = "text",
	countdownRef,
	timerDurationInSeconds = 180,
	startTimerOnInit = false,
	onResend,
	errorMessage,
}) => (
	<div className={styles.card}>
		<span className={styles.title}>{title}</span>
		<div className={styles.subtitle}>{subtitle}</div>

		{isVerifying ? (
			<div className={styles.loaderRow}>
				<span className={styles.spinner} />
				<span className={styles.loaderText}>Verifying… Please wait</span>
				<span className={styles.loaderHint}>Take 2 secs</span>
			</div>
		) : (
			<input
				className={styles.input}
				type={inputType}
				placeholder={placeholder}
				value={value}
				onChange={e => onChange(e.target.value)}
				autoComplete="one-time-code"
			/>
		)}

		{errorMessage && !isVerifying && (
			<p className={styles.error}>{errorMessage}</p>
		)}

		{!isVerifying && onResend && (
			<CountdownText
				ref={countdownRef}
				timerDurationInSeconds={timerDurationInSeconds}
				startTimerOnInit={startTimerOnInit}
				onResend={onResend}
			/>
		)}
	</div>
);

export default OtpVerificationCard;
